<div mat-dialog-title>
  <h3 class="title-dialog">
    <div class="news-title">
      {{ title() }}
    </div>
    <div *ngIf="category() as c" class="news-popup-category" [style]="{ borderColor: c.color, background: c.color + '33' }">
      {{ c.name }}
    </div>
  </h3>
  <button mat-icon-button mat-dialog-close [disableRipple]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="news-popup">
  <dx-scroll-view *ngIf="news$ | async as news" class="news-popup-body" height="100%">
    <ng-container *ngIf="!loading(); else loadingTemplate">
      <div *ngIf="news.updates.length" class="news-popup-updates">
        <div
          class="news-popup-updates-title"
          [style]="{
            borderBottomColor: news.category.color
          }"
        >
          Updates
        </div>
        <div class="news-popup-updates-item" *ngFor="let item of news.updates">
          <span class="news-popup-updates-item-date">{{ item.updateDate | date: "MM/dd/yyyy 'h' HH:mm" }}</span>
          <span style="white-space: pre-line">{{ item.text }}</span>
        </div>
      </div>
      <div class="news-popup-description" [innerHTML]="news.description"></div>
    </ng-container>
    <ng-template #loadingTemplate>
      <div class="loader-container">
        <mat-progress-spinner diameter="60" mode="indeterminate" strokeWidth="5"></mat-progress-spinner>
      </div>
    </ng-template>
  </dx-scroll-view>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="news-popup-publish">
    Published on <br /><strong>{{ publishDate() | date: "MMMM d, y 'h' HH:mm" }}</strong>
  </div>
  <div class="news-buttons">
    <brd-button
      class="news-buttons-left"
      text="prev"
      color="secondary"
      iconName="arrow-left-16"
      (clickEvent)="prevClick()"
      [style]="{ visibility: hasPrev() ? 'visible' : 'hidden' }"
    ></brd-button>
    <brd-button
      class="news-buttons-right"
      text="next"
      color="secondary"
      iconName="arrow-right-16"
      (clickEvent)="nextClick()"
      [style]="{ visibility: hasNext() ? 'visible' : 'hidden' }"
    ></brd-button>
  </div>
  <brd-button
    [style]="{ visibility: showGoToNewsButton() ? 'visible' : 'hidden', marginLeft: 'auto' }"
    text="see all news"
    (clickEvent)="goToNews()"
  ></brd-button>
</mat-dialog-actions>
